module.exports = __webpack_public_path__ + "static/media/heart-black.0a40fd9a.svg";